import { CcfBox, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-voice-internals-card.module.scss';
import { Lock } from '@mui/icons-material';

/* eslint-disable-next-line */
export interface CcfCopilotVoiceInternalsCardProps {
  internalInfo?: any;
  assetCardExpandCollapseHandler?: any;
  isCardExpanded?: any;
}

/**
 * CcfCopilotVoiceInternalsCard - used to display internal use only Information inside Copilot Voice Suggestion card
 * @param props -?-CcfCopilotVoiceInternalsCardProps
 * @example <CcfCopilotVoiceInternalsCard />
 */
export function CcfCopilotVoiceInternalsCard(
  props: CcfCopilotVoiceInternalsCardProps
) {
  return (
    <CcfBox className={styles.card} id='agent_copilot_internalUseOnly'>
      <CcfBox
        className={styles.titleRow}
        onClick={() => props?.assetCardExpandCollapseHandler('internalInfo')}
      >
        <CcfBox className={styles.title}>
          <Lock className={styles.internalInfoIcon} />
          <CcfTypography className={styles.titleTxt}>
            Internal Use Only
          </CcfTypography>
        </CcfBox>
      </CcfBox>
      {props?.isCardExpanded &&
        props?.internalInfo.map((internal: any) => {
          return (
            <CcfBox className={styles.internalInfoCard}>
              <CcfBox>
                <CcfTypography className={styles.title}>
                  {internal.title}
                </CcfTypography>
              </CcfBox>
              <CcfBox>
                <CcfTypography className={styles.description}>
                  {internal.description}
                </CcfTypography>
              </CcfBox>
            </CcfBox>
          );
        })}
    </CcfBox>
  );
}

export default CcfCopilotVoiceInternalsCard;
